import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m8.483 4.46-2.82 3.565a.7.7 0 0 1-.543.262H3.5a.12.12 0 0 0-.087.035.12.12 0 0 0-.035.084v3.188q.001.05.035.084a.12.12 0 0 0 .086.035H5.12c.213 0 .413.097.544.262l2.82 3.564zm-.455-1.363c.296-.118.625-.129.928-.03.303.1.56.302.724.571.152.25.215.542.181.83v11.064c.034.288-.029.58-.181.83a1.347 1.347 0 0 1-2.3-.01l-2.597-3.284H3.5a1.5 1.5 0 0 1-1.06-.432A1.46 1.46 0 0 1 2 11.594V8.406c0-.39.158-.766.44-1.042a1.5 1.5 0 0 1 1.06-.432h1.283L7.38 3.648c.149-.248.376-.442.648-.55m6.038.899a.697.697 0 0 1 .969-.101 7.9 7.9 0 0 1 2.186 2.722 7.74 7.74 0 0 1 0 6.766 7.9 7.9 0 0 1-2.186 2.722.697.697 0 0 1-.969-.1.67.67 0 0 1 .103-.953 6.5 6.5 0 0 0 1.808-2.253 6.4 6.4 0 0 0 0-5.598 6.5 6.5 0 0 0-1.808-2.253.67.67 0 0 1-.103-.952m-2.203 2.41c.228-.3.66-.36.964-.136a4.7 4.7 0 0 1 1.396 1.645 4.6 4.6 0 0 1 0 4.17 4.7 4.7 0 0 1-1.396 1.645.697.697 0 0 1-.964-.136.67.67 0 0 1 .137-.948 3.3 3.3 0 0 0 .99-1.167 3.26 3.26 0 0 0 0-2.958A3.3 3.3 0 0 0 12 7.354a.67.67 0 0 1-.137-.948",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }